'use client';

import { ListChecks, Map } from 'lucide-react';
import React from 'react';

// Import the new UI component
import { ViewToggleFloatingButton as UIViewToggleFloatingButton } from '@ui/components/features/search/viewToggleFloatingButton';

/**
 * ViewToggleFloatingButton - A wrapper around the UI ViewToggleFloatingButton component
 * that handles dynamic icon display for toggling between map and list views
 * on the search page.
 */
interface ViewToggleFloatingButtonProps {
  isMapDisplayMode: boolean;
  toggleViewMode: () => void;
}

export function ViewToggleFloatingButton({ isMapDisplayMode, toggleViewMode }: ViewToggleFloatingButtonProps) {
  // Define the icons to be used
  const mapIconNode = <Map className="w-6 h-6 text-orange-500" />;
  const listIconNode = <ListChecks className="w-6 h-6 text-orange-500" />;

  const ariaLabel = isMapDisplayMode ? 'Show list view' : 'Show map view';

  return (
    <UIViewToggleFloatingButton
      onClick={toggleViewMode}
      viewMode={isMapDisplayMode ? 'map' : 'list'} // 'map' mode means "currently showing map, button shows list icon"
      mapIcon={mapIconNode}
      listIcon={listIconNode}
      ariaLabel={ariaLabel}
    />
  );
}
